import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'

import styles from './StyledList.module.scss'

type Props = {
  iconDefault?: IconType
  items: {
    content: ReactNode
    icon?: IconType
  }[]
}

export const StyledList = ({ iconDefault, items }: Props) => (
  <ul className={styles.container}>
    {items.map(({ content, icon }, i) => {
      const iconName = icon || iconDefault

      return (
        <li key={i}>
          <span className={styles.bullets}>
            <span className={styles.icon}>{iconName ? <Icon name={iconName} /> : i + 1}</span>
          </span>
          <div className={styles.content}>{content}</div>
        </li>
      )
    })}
  </ul>
)
